import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

export const SocialContainer = styled.section`
  padding: 30px 16px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  background-color: ${({ theme }) => theme.base.black};
  color: ${({ theme }) => theme.base.white};

  a {
    color: ${({ theme }) => theme.base.white};
  }
  h2 {
    color: ${({ theme }) => theme.base.white};
    margin-bottom: 30px;
  }

  ${breakpoints.lg} {
    padding: 50px 40px;
    height: 435px;
  }

  ${breakpoints.md} {
    h2 {
      margin-bottom: 50px;
      margin-top: 15px;
    }
    padding: 30px 30px 0;
  }
`;

export const ContentContainer = styled.div`
  flex: 0 100%
  z-index: 1;
  margin-bottom: 35px;

  ${breakpoints.lg} {
    flex: 0 50%;
    top: -424px;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 35px;
  a:first-of-type {
    margin: 0;
    margin-right: 10px;
  }
  a {
    margin: 10px 10px 0 0;
  }
  ${breakpoints.md} {
    margin-bottom: 35px;
    margin-top: 50px;
  }
`;

export const ImageContainer = styled.div`
  flex: 0 50%;
  display: none;
  z-index: 1;

  ${breakpoints.lg} {
    display: flex;
  }
`;

export const PhoneImage = styled.img`
  width: auto;
  margin-left: 100px;
  height: calc(100% + 32px);
  bottom: 0;
  position: absolute;

  ${breakpoints.xl} {
    margin-left: 200px;
  }
`;

export const SocialBackgroundImg = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  max-width: 1360px;
  width: 100%;
  z-index: 1;
  display: flex;
  margin: 0 auto;
`;
